module.exports = __webpack_public_path__ + "img/sharedMediaWithSpaceStorageMedias.8c5f2a3c.svg";